module.exports = __webpack_public_path__ + "img/39-CAMICIA-SUSHI-SMLXL-COLORI-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO1.b0a2878f.jpg";